import {LayoutComponent} from "@/components/layout/layout-component";

export class AppComponent {
    static defineElements() {
        window.customElements.define('kaart-melding', LayoutComponent);
    }
}
